/**
 * @Author: luoob
 * @Date: 2021-10-30 12:09:46
 * @Last Modified by: luoob
 * @Last Modified time: 2021-10-30 12:09:54
 * @Introduction: article storage 模块
 */

const ARTICLE_KEY = 'ARTICLE'

/**
 * 存储文章
 * @date 2021-10-30
 * @param {string} content
 * @returns {any}
 */
const setArticle = (content: string) => {
    sessionStorage.setItem(ARTICLE_KEY, content)
}
/**
 * 获取存储的文章
 * @date 2021-10-30
 * @returns {any}
 */
const getArticle = () => {
    return sessionStorage.getItem(ARTICLE_KEY)
}
/**
 * 移除文章存储
 * @date 2021-10-30
 * @returns {any}
 */
const removeArticle = () => {
    sessionStorage.removeItem(ARTICLE_KEY)
}

export default {
    set: setArticle,
    get: getArticle,
    remove: removeArticle
}
